import { Button, Stack, Typography } from '@mui/material';
import { buttonBaseStyle } from '@/styles/constant';
import LoginForm from '@/components/login/LoginForm';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const BOX_WIDTH = 450;
const BOX_HEIGHT = 560;

export default function Login() {
  const { t } = useTranslation();

  return (
    <Stack direction="row">
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ width: BOX_WIDTH, height: BOX_HEIGHT, bgcolor: 'white', borderRadius: '35px 0 0 35px' }}
      >
        <img src={'/images/common/logo.png'} alt="logo" width={300} />
        <br />
        <Link to="/sign-up">
          <Button
            sx={{
              ...buttonBaseStyle,
              border: '1px solid #4FD1C5',
              color: '#4FD1C5',
            }}
          >
            {t('Login.label.signUpButton')}
          </Button>
        </Link>
      </Stack>
      <LoginForm width={BOX_WIDTH} height={BOX_HEIGHT} buttonStyle={buttonBaseStyle} />
    </Stack>
  );
}
